import { SET_DATE } from './actionTypes';

export const setDate = (date) => (dispatch) => {
  dispatch({
    type: SET_DATE,
    dateObject: date,
  });
};
